import { createSlice } from '@reduxjs/toolkit';

interface UserSessionState {
  loading: boolean;
  error: string | null;
}

const initialState: UserSessionState = {
  loading: false,
  error: null,
};

const userSessionSlice = createSlice({
  name: 'userSession',
  initialState,
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    error: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { loading, error } = userSessionSlice.actions;

export default userSessionSlice.reducer;
